import { useDeviceType } from '@cian/ui-kit';
import classNames from 'clsx';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';

import { useSpecialProjectParameters } from './hooks';
import * as styles from './styles.css';
import { BANNER_ID } from '../../constants/banners';
import { selectIsOpen } from '../../selectors/searchResults';
import { AdBannerMicrofrontendContainer } from '../AdBannerMicrofrontendContainer';

import type { IMicrofrontendManifest } from '@cian/mf-registry/shared';

export interface IAdBannerMicrofrontendSpecialProjectContainerProps {
  manifest: IMicrofrontendManifest;
  /** Застройщик выбранного размещения — от него зависит место показа в аналитике */
  developerId: number;
  onStub?(): void;
  onError?(): void;
  onClose?(): void;
}

/** Место «adfox-баннер спецпроекта на карте», отрисованное микрофронтендом рекламных баннеров */
export const AdBannerMicrofrontendSpecialProjectContainer: React.FC<
  IAdBannerMicrofrontendSpecialProjectContainerProps
> = ({ manifest, developerId, onStub, onError, onClose }) => {
  const deviceType = useDeviceType();
  const isSearchResultsOpen = useSelector(selectIsOpen);
  const parameters = useSpecialProjectParameters(developerId);
  const [bannerContainer, setBannerContainer] = React.useState<HTMLElement | null>(null);

  const isDesktop = deviceType === 'desktop';

  /**
   * На мобилке баннер показывается над шапкой — в контейнере, отрисованном на ноде.
   * Легаси-шаблон монтировался туда же.
   */
  React.useEffect(() => {
    if (!isDesktop) {
      setBannerContainer(document.getElementById(BANNER_ID));
    }
  }, [isDesktop]);

  const microfrontend = (
    <AdBannerMicrofrontendContainer
      manifest={manifest}
      parameters={parameters}
      onStub={onStub}
      onError={onError}
      onClose={onClose}
    />
  );

  if (!isDesktop) {
    return bannerContainer ? ReactDOM.createPortal(microfrontend, bannerContainer) : null;
  }

  return (
    <div
      data-testid="ad-banner-microfrontend-special-project"
      className={classNames(styles['container'], isSearchResultsOpen && styles['container--moved'])}
    >
      {microfrontend}
    </div>
  );
};
